import { EntityId } from "@jackfruit/common"
import { useEffect } from "react"
import { useProcessActions } from "~/hooks/useProcessActions"
import { useProductIdFromUrl } from "./useProductIdFromUrl"
import { useTemplateIdFromUrl } from "./useTemplateIdFromUrl"

export const useBootstrapProductFeed = (blockId: EntityId) => {
  const productId = useProductIdFromUrl()
  const templateId = useTemplateIdFromUrl()
  const process = useProcessActions()

  useEffect(() => {
    process.bootstrapProductFeed({ blockId, productId, templateId })
  }, [blockId, productId, templateId, process])
}
